<template>
    <div class="pb-20 pt-20">
        <div class="container mx-auto grid grid-cols-1 p-3 sm:w-full md:w-4/12">

            <div class="bg-white p-5 rounded-md shadow-md mb-5">
                <div class="flex flex-col justify-center items-center relative">
                    <div>
                        <div class="rounded-full mb-2 w-28 h-28 p-2 bg-gray-100">
                            <img :src="user.avatar" class="rounded-full object-cover">
                        </div>
                        <div class="font-bold text-xl">
                            {{ user.name }}
                        </div>
                        <div class="font-normal italic text-sm">
                            {{ user.email }}
                        </div>
                    </div>
                    <div class="absolute top-0 right-0 text-yellow-500">
                        <router-link :to="{name: 'profile'}">
                            <i class="fa fa-edit" aria-hidden="true"></i>
                        </router-link>
                    </div>
                    <a @click="logout" style="cursor:pointer">
                        <div class="bg-yellow-500 px-3 py-2 mt-8 rounded-md shadow-md mb-3 text-lg font-semibold text-white focus:outline-none focus:bg-yellow-600">
                            <i class="fa fa-sign-out-alt mr-1" aria-hidden="true"></i> Logout
                        </div>
                    </a>
                </div>
            </div>

            <!-- <div class="bg-white p-5 rounded-md shadow-md mb-5"> -->

                <!-- <router-link :to="{name: 'profile.password'}">
                    <div class="grid grid-cols-5 gap-4 bg-yellow-500 px-3 py-2 rounded-md shadow-sm mb-3 text-lg font-semibold text-white focus:outline-none focus:bg-yellow-600">
                        <div class="col-span-5">
                            <i class="fa fa-key mr-2" aria-hidden="true"></i> Ubah Password
                        </div>
                    </div>
                </router-link> -->

            <!-- </div> -->

        </div>
    </div>
</template>

<script>

    //hook vuex
    import { useStore } from 'vuex'

    //hook vue router
    import { useRouter } from 'vue-router'
    
    //hook vue
    import { computed, onMounted } from 'vue'

    //hook Toast
    import { useToast } from "vue-toastification"

    export default {

        setup() {

            //store vuex
            const store = useStore()

            //vue router
            const router = useRouter()

            // Same interface as this.$toast
            const toast = useToast()

            //mounted
            onMounted(() => {
                //panggil action "getUser" dari module "auth" vuex
                store.dispatch('auth/getUser')

            })

            //data user login
            const user = computed(() => {
                return store.state.auth.user
            })

            //method logout
            function logout() {

                //panggil action "logout" di dalam module "auth"
                store.dispatch('auth/logout')
                .then(() => {

                    //jika berhasil, akan di arahkan ke route login
                    router.push({
                        name: 'login'
                    })

                    toast.success("Logout Berhasil!")

                })

            }

            //return a state and function
            return {
                logout,     // <-- method logout
                user,       // <-- state user
            }

        }
    }
</script>

<style>

</style>